import { createContext } from 'react';

export interface CustomerContextType {
  customerName?: string;
  tenantId: string;
  customerId?: string;
}

/**
 * Context to store and provide customer information for a component tree.
 * Currently the name and tenant id of the customer are stored here and used in the CallConfirmationModal.
 * But this context can be used to store and provide any customer related information, Contacts, Addresses etc.
 */
const CustomerContext = createContext<CustomerContextType | undefined>(
  undefined,
);

export default CustomerContext;
